import React, { PureComponent } from 'react';

export class TanksSearchBar extends PureComponent<any, any> {

    render() {

        return (
            <div className="bar-position">
                <h2 className='text-light'>
                    Mahutid
                </h2>
                <div className="card mb-5">
                    <div className="card-body">
                        <div className='d-flex flex-wrap flex-sm-nowrap'>                            
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}